import * as React from 'react';
import styles from './errorText.module.scss';

export default function ErrorText({ error }: { error: string }) {
  return <div className={styles.errorText}>{error}</div>;
}
